"use client";

/*eslint-disable */
import React from "react";
import { Link } from "react-router-dom";

interface DetalleProps {
  category: any;
}

const RelacionadosComponent: React.FC<DetalleProps> = ({ category }) => {
  const baseURL = typeof window !== "undefined" ? window.location.origin : "";
  return (
    <>
      <div className="blog-area">
        <div className="container justify-content-center">
          <div
            className="section-title"
            data-aos="fade-up"
            data-aos-duration="800"
            data-aos-once="true"
          >
            <h2 className="nunito-font">También te puede interesar</h2>
          </div>
          <div className="row">
            {category?.length > 0 ? (
              category?.slice(-6).map((item: any, index: number) => (
                <div
                  key={index}
                  className="col-6 col-md-4 col-xl-2 col-lg-3 mb-4"
                  data-aos="fade-up"
                  data-aos-duration="800"
                  data-aos-once="true"
                >
                  <div className="single-blog-post">
                    <div className="image">
                      <a
                        href={`${baseURL}/producto/${item.slug}`}
                        className="d-block"
                      >
                        <img
                          src={item?.name !== "Laboratorios" ? `/images/fotos/300x300/${item?.slug?.replace(/[^a-zA-Z0-9]/g, "-")}.webp` : "/images/laboratorios.webp"}
                          alt={item.name}
                          width={860}
                          height={545}
                          onError={(e) => { e.currentTarget.src = "/images/productos.webp"; }}
                        />
                      </a>
                    </div>
                    <div className="content">
                      <h3>
                        <a href={`${baseURL}/producto/${item.slug}`}>
                          {item.name}
                        </a>
                      </h3>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="col-12">
                <p>No hay productos disponibles en esta categoría.</p>
              </div>
            )}
          </div>
          <div className="w-100 mb-4 mt-4" style={{textAlign: "center"}}>
            <Link
              to="/productos"
              className="btn-style-one gris-orange-color mb-4 mx-auto"
              data-aos="fade-right"
              data-aos-duration="800"
              data-aos-once="true"
              data-aos-delay="300"
            >
              Ver todos los productos{" "}
              {/* <i className="bx bx-chevron-right"></i> */}
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default RelacionadosComponent;
